<template>
  <div>
    <section>
      <header class="padding-bottom-15">预处理单号:{{shipmentNo}}</header>
      <Table :columns="columns"
             :data="headData"
             size="small"
             ref="table"
             border
             stripe></Table>
    </section>
    <section class="margin-top-15">
      <div v-for="(data,key) of subData"
           :key="key">
        <header class="padding-bottom-15">
          子单据预处理单号:<router-link :to="{name:'spBill',query:{CN_shipmentNo:key}}">{{key}}</router-link>
        </header>
        <Table :columns="columnsbill"
               :data="data"
               size="small"
               ref="table"
               border
               stripe></Table>
      </div>
    </section>
    <Spin size="large"
          fix
          v-if="loading"></Spin>
  </div>
</template>
<script>
import { HttpShipBillLogistic } from '@/service/boss/shipment'
import language from './language.json'
export default {
  props: ['shipmentNo'],
  data () {
    return {
      loading: false,
      headData: [],
      subData: {},
    }
  },
  created () {
    this.getDetail();
  },
  methods: {
    async getDetail () {
      this.loading = true;
      HttpShipBillLogistic({
        shipmentNo: this.shipmentNo
      }).then(res => {
        const data = res.data || {};
        this.headData = data.head_history;
        this.subData = data.sub_history;
      }, err => {
        this.$VMessage.error({
          content: err.message,
          duration: 30,
          closable: true
        });
      }).finally(() => {
        this.loading = false;
      })
    },
  },
  computed: {
    columns () {
      return [{
        title: '订单状态',
        key: 'order_status',
        render (h, { row }) {
          const status = [
            "已创建",
            "已提交",
            "已退回",
            "已审批",
            "报价已确认",
            "已取消",
            "已确认订舱",
            "已发运",
            "已到达",
            "草稿状态",
            "验收关闭"
          ];
          return <span>{status[row.order_status]}</span>
        }
      },
      {
        title: '物流状态',
        key: 'logistics_status',
        render (h, { row }) {
          const status = [
            "初始化",
            "待订舱",
            "已订舱",
            "已报关",
            "已发船",
            "已到港",
            "已清关",
            "中转仓到达",
            "已打托",
            "已预约",
            "已妥投",
            "查验中"
          ];
          return <span>{status[row.logistics_status]}</span>
        }
      }, {
        title: '发票状态',
        key: 'invoice_status',
        render (h, { row }) {
          const status = {
            '10': '发票未上传',
            '20': '发票已上传',
            '30': '发票已确认'
          }
          return <span>{status[row.invoice_status]}</span>
        }
      }, {
        title: '操作人',
        key: 'op_name',
      }, {
        title: '操作时间',
        key: 'operate_at',
      }, {
        title: '备注',
        key: 'memo',
      }, {
        title: '附加信息',
        key: 'meta',
        render (h, { row }) {
          const meta = JSON.parse(row.meta || "{}");
          return Object.keys(meta).map(function (key) {
            if (/(_url)$/.test(key)) {
              return <a style="display:block;" href={meta[key]}>{language[key]}:{meta[key.replace('_url', '_src')]}</a>
            }
            if (/(_src)$/.test(key)) return null;
            if ('transport_type' === key) return meta['transport_type'] == 0 ? '直发' : '中转';
            return <div>{language[key]}:{meta[key]}</div>
          });
          // return <div style="white-space:nowrap">{vnode}</div>
        }
      }, {
        title: '附件',
        key: 'attaches',
        render (h, { row }) {
          const attaches = row.attaches || [];
          return attaches.map(function (item) {
            return <a style="display:block;" href={item.attach_url}>{item.attach_name}</a>
          })
        }
      }
      ]
    },
    columnsbill () {
      return [{
        title: '订单状态',
        key: 'order_status',
        render (h, { row }) {
          const status = [
            "已创建",
            "已提交",
            "已退回",
            "已审批",
            "报价已确认",
            "已取消",
            "已确认订舱",
            "已发运",
            "已到达",
            "草稿状态",
            "验收关闭"
          ];
          return <span>{status[row.order_status]}</span>
        }
      },
      {
        title: '物流状态',
        key: 'logistics_status',
        render (h, { row }) {
          const status = [
            "初始化",
            "待订舱",
            "已订舱",
            "已报关",
            "已发船",
            "已到港",
            "已清关",
            "中转仓到达",
            "已打托",
            "已预约",
            "已妥投",
            "查验中"
          ];
          return <span>{status[row.logistics_status]}</span>
        }
      }, {
        title: '操作人',
        key: 'op_name',
      }, {
        title: '操作时间',
        key: 'operate_at',
      }, {
        title: '备注',
        key: 'memo',
      }, {
        title: '附加信息',
        key: 'meta',
        render (h, { row }) {
          return <pre>{row.meta}</pre>
        }
      }
      ]
    }

  }
}
</script>
